import { gql } from '@apollo/client'
import {
  CourseInvite,
  CourseOrderItem,
  OrderCustomerDetails,
  CourseDiscInstUrlInfo,
  CourseInviteProvider
} from 'share/domain/course'

export const GET_COURSE_DASHBOARD = gql`
  query GET_COURSE_DASHBOARD($caseId: Int!) {
    orders {
      courseDashboard(caseId: $caseId) {
        invites {
          courseNumber
          orderId
          coursePaymentType
          courseProviders {
            orderItemId
            productKey
            name
            price
            valueProps
          }
        }
        orders {
          courseNumber
          orderId
          orderItemId
          isJoint
          providerId
          providerName
          courseType
          courseStatus
          courseMethod
          coursePaymentType
          coursePrice
          coursePhoneNumber
          courseAccessCode
          courseCompletionDate
          courseCertificationExpirationDate
          verifiedDetails
          verifiedCoDebtorDetails
          acceptedDisclosureAgreement
          shownCourseInstructions
          hasRegisteredCourse
        }
      }
    }
  }
`

export interface GetCourseDashboardVariables {
  caseId: number
}

export interface GetCourseDashboardResponse {
  orders: {
    courseDashboard: {
      invites: CourseInvite[]
      orders: CourseOrderItem[]
    }
  }
}

export const GET_ORDER_PRIMARY_APPLICANT_CUSTOMER_DETAILS = gql`
  query GET_ORDER_PRIMARY_APPLICANT_CUSTOMER_DETAILS(
    $request: GetOrderPrimaryApplicantCustomerDetailRequestDtoInput!
  ) {
    orders {
      orderPrimaryApplicantCustomerDetails(request: $request) {
        caseId
        orderId
        orderKey
        personId
        firstName
        lastName
        middleName
        homePhone
        mobilePhone
        workPhone
        emailAddress
        street
        zip
        city
        state
      }
    }
  }
`

export interface GetOrderPrimaryApplicantCustomerDetailsVariables {
  request: {
    caseId: number
    orderId: number
  }
}

export interface GetOrderPrimaryApplicantCustomerDetailsResponse {
  orders: {
    orderPrimaryApplicantCustomerDetails: OrderCustomerDetails
  }
}

export const GET_ORDER_CO_DEBTOR_CUSTOMER_DETAILS = gql`
  query GET_ORDER_CO_DEBTOR_CUSTOMER_DETAILS(
    $request: GetOrderCoDebtorCustomerDetailRequestDtoInput!
  ) {
    orders {
      orderCoDebtorCustomerDetails(request: $request) {
        caseId
        orderId
        orderKey
        personId
        firstName
        lastName
        middleName
        homePhone
        mobilePhone
        workPhone
        emailAddress
        street
        zip
        city
        state
      }
    }
  }
`

export interface GetOrderCoDebtorCustomerDetailsVariables {
  request: {
    caseId: number
    orderId: number
  }
}

export interface GetOrderCoDebtorCustomerDetailsResponse {
  orders: {
    orderCoDebtorCustomerDetails: OrderCustomerDetails
  }
}

export const GET_COURSE_DISC_INST_URL_INFO = gql`
  query GET_COURSE_DISC_INST_URL_INFO(
    $request: CourseDiscInstUrlInfoRequestDtoInput!
  ) {
    orders {
      courseDiscInstUrlInfo(request: $request) {
        courseNumber
        courseOrderItemId
        courseUrl
        instructions
        disclosureContent
        disclosureVersion
        info1
        info2
      }
    }
  }
`

export interface GetCourseDiscInstUrlInfoVariables {
  request: {
    caseId: number
    orderId: number
    courseType: number
    courseMethodType: number
  }
}

export interface GetCourseDiscInstUrlInfoResponse {
  orders: {
    courseDiscInstUrlInfo: CourseDiscInstUrlInfo
  }
}

export const CERTIFICATE_EXISTS_BY_CASE = gql`
  query CERTIFICATE_EXISTS_BY_CASE($caseId: Int!) {
    orders {
      creditCounselingCertificateExistsByCaseId(caseId: $caseId) {
        caseId
        creditCounselingCertificateExists
      }
    }
  }
`

export interface CertificateExistsByCaseVariables {
  caseId: number
}

export interface CertificateExistsByCaseResponse {
  orders: {
    creditCounselingCertificateExistsByCaseId: {
      caseId: number
      creditCounselingCertificateExists: boolean
    }
  }
}

export const GET_PLACE_NEW_COURSE_ORDER_CLIENT_PAYS_PRODUCTS = gql`
  query GET_PLACE_NEW_COURSE_ORDER_CLIENT_PAYS_PRODUCTS(
    $request: GetPlaceNewCourseOrderClientPayProductsRequestDtoInput!
  ) {
    orders {
      placeNewCourseOrderClientPayProducts(request: $request) {
        success
        errorMessage
        hasPlacedFirstCourseOrder
        hasPlacedSecondCourseOrder
        hasPlacedFirstCourseOrderStatus
        hasPlacedSecondCourseOrderStatus
        firstCourseOrderStep
        secondCourseOrderStep
        isDebtor1
        orderItemSourceTypeId
        courseProviders {
          productKey
          name
          price
          valueProps
        }
      }
    }
  }
`

export interface GetPlaceNewCourseOrderClientPaysProductsVariables {
  request: {
    caseId: number
    courseType: number
    isDebtor1: boolean
  }
}

export interface GetPlaceNewCourseOrderClientPaysProductsResponseData {
  success: boolean
  errorMessage: string
  hasPlacedFirstCourseOrder: boolean | null
  hasPlacedSecondCourseOrder: boolean | null
  hasPlacedFirstCourseOrderStatus: number | null
  hasPlacedSecondCourseOrderStatus: number | null
  firstCourseOrderStep: number | null
  secondCourseOrderStep: number | null
  courseProviders: CourseInviteProvider[]
  isDebtor1: boolean
  orderItemSourceTypeId: number | null
}

export interface GetPlaceNewCourseOrderClientPaysProductsResponse {
  orders: {
    placeNewCourseOrderClientPayProducts: GetPlaceNewCourseOrderClientPaysProductsResponseData
  }
}
